import {
	pagination,
} from '../actions';

const initialState = {};

const paginationReducer = (state = initialState, action) => {
	switch (action.type) {
		case pagination.CHANGE_PAGE:
			return {
				...state,
				[action.query]: {
					// This is the default initial page count
					// it will get overwritten if defined in state
					perPage: 10,
					...state[action.query],
					page: action.nextPage,
				},
			};
		case pagination.CHANGE_PAGE_LIMIT:
			return {
				...state,
				[action.query]: {
					// Default to the first page when page limit has changed
					// if an overriding page has not been specified
					page: 0,
					...state[action.query],
					perPage: action.newPageLimit,
				},
			};
		case pagination.CHANGE_SORT:
			return {
				...state,
				[action.query]: {
					// Default to the first page when page limit has changed
					// if an overriding page has not been specified
					page: 0,
					perPage: 10,
					...state[action.query],
					sortBy: action.newSortBy,
					sortDirection: action.newSortDirection,
					sortByResolver: action.sortByResolver,
				},
			};
		default:
			return state;
	}
};

export default paginationReducer;
